import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	mode: 'hash',
	routes: [
		{
			path: '*',
			redirect: '/'
		}, {
			path: '/',
			name: 'PageView',
			component: resolve => require(['@/view/PageView'], resolve),
			children: [
				{
					path: '/',
					redirect: '/home'
				}, {
					path: '/home',
					name: 'Home',
					component: resolve => require(['@/view/HomePage'], resolve),
					meta: {
						title: 'Co-Health Home'
					}
				}, {
					path: '/products',
					name: 'products',
					component: resolve => require(['@/view/Products'], resolve),
					meta: {
						title: 'Co-Health Products'
					}
				}, {
					path: '/customizable',
					name: 'Customizable',
					component: resolve => require(['@/view/Customizable'], resolve),
					meta: {
						title: 'Co-Health Customizable'
					}
				}, {
					path: '/software',
					name: 'Software',
					component: resolve => require(['@/view/Software'], resolve),
					meta: {
						title: 'Co-Health Software'
					}
				}, {
					path: '/aboutUs',
					name: 'AboutUs',
					component: resolve => require(['@/view/AboutUs'], resolve),
					meta: {
						title: 'Co-Health About us'
					}
				}
			]
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js